export const FETCH_NEW_UPDATES_REQUEST = "FETCH_NEW_UPDATES_REQUEST";
export const FETCH_NEW_UPDATES_SUCCESS = "FETCH_NEW_UPDATES_SUCCESS";
export const FETCH_NEW_UPDATES_FAILURE = "FETCH_NEW_UPDATES_FAILURE";

export const fetchNewUpdatesRequest = (params) => ({
  type: FETCH_NEW_UPDATES_REQUEST,
  payload: params,
});

export const fetchNewUpdatesSuccess = (data) => ({
  type: FETCH_NEW_UPDATES_SUCCESS,
  payload: data,
});

export const fetchNewUpdatesFailure = (error) => ({
  type: FETCH_NEW_UPDATES_FAILURE,
  payload: error,
});
